/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type DeleteClientPhotoMutationVariables = Types.Exact<{
  input: Types.ClientPhotoDeleteInput;
}>;
export type DeleteClientPhotoMutation = {
  __typename?: "Mutation";
  clientPhotoDelete?: {
    __typename?: "ClientPhotoDeletePayload";
    result: {
      __typename?: "ClientPhotoDeleteError";
      code: Types.ClientPhotoDeleteErrorCode;
    } | {
      __typename?: "ClientPhotoDeleteSuccess";
      id: string;
    };
  } | null;
};
export const DeleteClientPhotoDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "deleteClientPhoto"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ClientPhotoDeleteInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "clientPhotoDelete"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientPhotoDeleteError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "code"
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientPhotoDeleteSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "id"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type DeleteClientPhotoMutationFn = Apollo.MutationFunction<DeleteClientPhotoMutation, DeleteClientPhotoMutationVariables>;

/**
 * __useDeleteClientPhotoMutation__
 *
 * To run a mutation, you first call `useDeleteClientPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientPhotoMutation, { data, loading, error }] = useDeleteClientPhotoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientPhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientPhotoMutation, DeleteClientPhotoMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<DeleteClientPhotoMutation, DeleteClientPhotoMutationVariables>(DeleteClientPhotoDocument, options);
}
export type DeleteClientPhotoMutationHookResult = ReturnType<typeof useDeleteClientPhotoMutation>;
export type DeleteClientPhotoMutationResult = Apollo.MutationResult<DeleteClientPhotoMutation>;
export type DeleteClientPhotoMutationOptions = Apollo.BaseMutationOptions<DeleteClientPhotoMutation, DeleteClientPhotoMutationVariables>;